<div class="header" [ngClass]="{'header--top': true}" #header>
    <div class="header-desktop desktop-only">
        <div routerLink="" class="header-logo" (click)="track('header-site-logo')">
            <img src="assets/logos/logo-screen-for-epi.svg" alt="EPI Screening Tool Logo">
        </div>
        <div class="nav-menu">
            <a #navLink routerLink="/home" class="menu-item" (mouseenter)="setUnderlinePosition(0)" (mouseleave)="activeRouteUnderlinePosition()" (click)="track('header-home')">
                <p class="menu-item__title">Home</p>
            </a>
            <a #navLink routerLink="/what-is-epi" class="menu-item" (mouseenter)="setUnderlinePosition(1)" (mouseleave)="activeRouteUnderlinePosition()" (click)="track('header-what-is-epi')">
                <p class="menu-item__title">What is EPI?</p>
            </a>
            <a #navLink class="menu-item" (mouseenter)="setUnderlinePosition(2)" (mouseleave)="activeRouteUnderlinePosition()">
                <div class="menu-item__hotspot" routerLink="/development" (click)="track('header-development')"></div>
                <p class="menu-item__title">Development</p>
                <div class="menu-item__dropdown" #developmentDropdown>
                    <div *ngFor="let tab of developmentTabs" class="dropdown-item" 
                        (click)="goToRoute($event, '/development', {fragment: tab.route, trackingId: 'header-development-' + tab.route})" 
                        [ngClass]="{'active-fragment': activeRouteFragment === tab.route}"> 
                        {{tab.name}} 
                    </div>
                </div>
            </a>
            <a #navLink class="menu-item" class="menu-item" (mouseenter)="setUnderlinePosition(3)" (mouseleave)="activeRouteUnderlinePosition()">
                <div class="menu-item__hotspot" routerLink="/screening-tool-landing" (click)="goToRoute($event, '/screening-tool-landing', {trackingId: 'header-screening-tool'})"></div>
                <p class="menu-item__title">The screening tool</p>
                <div class="menu-item__dropdown" #toolDropdown>
                    <div *ngFor="let tab of screeningToolTabs" class="dropdown-item" 
                    (click)="goToRoute($event, '/screening-tool-landing', {fragment: tab.route, trackingId: 'header-screening-tool-' + tab.route})" [ngClass]="{'active-fragment': activeRouteFragment === tab.route}">{{tab.name}}</div>
                </div>
            </a>
            <a #navLink routerLink="/faqs" class="menu-item" class="menu-item" (mouseenter)="setUnderlinePosition(4)" (mouseleave)="activeRouteUnderlinePosition()" (click)="track('header-faqs')">
                <p class="menu-item__title">FAQs</p>
            </a>
            <div *ngIf="underlineDisplay" class="nav-underline" [ngStyle]="{left: underlineDisplay.offset + 'px', width: underlineDisplay.width + 'px'}"></div>
        </div>
    </div>
    <div class="header-mobile mobile-only">
        <div routerLink="" class="mobile__logo" (click)="track('header-site-logo')">
            <img src="assets/logos/logo-screen-for-epi.svg" alt="EPI Screening Tool Logo">
        </div>
        <div class="circle-button" (click)="!mobileNavIsShowing? expandMobileNav() : collapseMobileNav()" #hamburgerMenu>
            <img *ngIf="!mobileNavIsShowing; else closeMobileMenu" src="assets/icons/icon-hamburger.svg" alt="Hamburger menu">
            <ng-template #closeMobileMenu>
                <img src="assets/icons/icon-x.svg" alt="Close menu">
            </ng-template>
        </div>
        <div class="mobile__drawer" #drawer>
            <div class="mobile__drawer-top">
            </div>
            <div class="mobile__outline"></div>
            <div class="mobile__nav">
                <div class="mobile__menu-item" routerLink="/home" [ngClass]="{active: activeRoute === '/home'}" (click)="track('header-home')">Home</div>
                <div class="mobile__menu-item" routerLink="/what-is-epi" [ngClass]="{active: activeRoute === '/what-is-epi'}" (click)="track('header-what-is-epi')">What is EPI?</div>
                <div class="mobile__menu-item" (click)="openMobileDropdown('development')" [ngClass]="{'active': mobileDropdown === 'development' || activeRoute === '/development'}">Development
                    <img *ngIf="mobileDropdown !== 'development' && activeRoute !== '/development'; else developmentOpen" src="assets/icons/icon-dropdown-arrow-white.svg" alt="Dropdown arrow">
                    <ng-template #developmentOpen>
                        <img src="assets/icons/icon-dropdown-arrow-black.svg" [ngClass]="{ 'rotate0': mobileDropdown !== 'development'}" alt="Dropdown arrow">
                    </ng-template>
                </div>
                <div class="mobile__dropdown" #devDropdown>
                    <div *ngFor="let tab of developmentTabs" class="mobile__menu-item mobile__menu-item--tab" [ngClass]="{'active-fragment': activeRouteFragment === tab.route}" routerLink="development" [fragment]="tab.route" #devTabList 
                        (click)="track('header-development-' + tab.route)"> 
                        {{tab.name}}
                    </div>
                </div>
                <div class="mobile__menu-item" (click)="openMobileDropdown('screening-tool')" [ngClass]="{'active': mobileDropdown === 'screening-tool' || activeRoute === '/screening-tool-landing'}">The screening tool
                    <img *ngIf="mobileDropdown !== 'screening-tool' && activeRoute !== '/screening-tool-landing'; else screeningToolOpen" src="assets/icons/icon-dropdown-arrow-white.svg" alt="Dropdown arrow">
                    <ng-template #screeningToolOpen>
                        <img src="assets/icons/icon-dropdown-arrow-black.svg" [ngClass]="{ 'rotate0': mobileDropdown !== 'screening-tool'}" alt="Dropdown arrow">
                    </ng-template>
                </div>
                <div class="mobile__dropdown" #screeningDropdown>
                    <div *ngFor="let tab of screeningToolTabs" class="mobile__menu-item mobile__menu-item--tab" [ngClass]="{'active-fragment': activeRouteFragment === tab.route}" 
                        (click)="goToRoute($event, '/screening-tool-landing', {fragment: tab.route, trackingId: 'header-screening-tool-' + tab.route})"
                        #screeningTabList> 
                        {{tab.name}} 
                    </div>
                </div>
                <div class="mobile__menu-item" routerLink="/faqs" [ngClass]="{active: activeRoute === '/faqs'}" (click)="track('header-faqs')">FAQs</div>
            </div>
        </div>
    </div>
</div>
<div class="mobile__menu-overlay" #mobileOverlay></div>
